export default "__VITE_ASSET__DzZOWqBN__ 480w, __VITE_ASSET__BlR$bBUp__ 768w, __VITE_ASSET__D9eRaIxK__ 1200w, __VITE_ASSET__bqH10TUO__ 1600w";